import { useParams } from "react-router-dom";
import SelectGroupsForm from "../../../ui/pages/ManagerCataloguePage/ui/components/SelectGroupsForm";

export default function ManageCourseCatalogue() {
  const { courseId } = useParams();
  return <SelectGroupsForm courseId={courseId} />;
}
